document.addEventListener('DOMContentLoaded', function() {
  const couponsWrapperList = document.querySelector('.discount-list');
  const offerBadgeWrappers = document.querySelectorAll('#offer-badge-wrapper');
    
    offerBadgeWrappers.forEach(function(wrapper) {
        wrapper.append(couponsWrapperList.cloneNode(true)); // Clone the list for each wrapper
    });
})